import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF } from '../data/site';
import { QuoteForm } from './QuoteForm';
const steps = [{
  title: 'Tell Us About The Job',
  text: 'Share the vehicle, room or building and what happened to the glass.'
}, {
  title: 'Confirm Details & Measurements',
  text: 'We review options, then take exact measurements when the job needs them.'
}, {
  title: 'Schedule The Right Service',
  text: 'We book the service and technician suited to your glass and timing.'
}];
export function QuotePath() {
  return <section id="quote" aria-labelledby="quote-heading" className="w-full bg-white" data-id="element-243" data-mp="2gskrfs6fafos">
      <div className="mx-auto max-w-shell px-[18px] py-12 sm:px-6 lg:py-20" data-id="element-244" data-mp="2lqw03zkzek5f">
        <h2 id="quote-heading" className="max-w-[640px] text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-245" data-mp="2lsyzvbbxrrnc">
          From First Question To Finished Glass
        </h2>

        <div className="mt-9 grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_440px] lg:gap-16" data-id="element-246" data-mp="18aztue3s6bof">
          <div data-id="element-247" data-mp="13c6hwq456sqd">
            <ol className="divide-y divide-kosin-line border-t border-kosin-line" data-id="element-248" data-mp="13coj815nvx55">
              {steps.map((step, i) => <li key={step.title} className="flex gap-5 py-6" data-id="element-249" data-mp="1ia77l2efg8c2" data-mpi={i}>
                  <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-kosin-charcoal text-[14px] font-semibold text-white" aria-hidden="true" data-id="element-250" data-mp="1d9t9ac2mocr8">
                    {i + 1}
                  </span>
                  <div data-id="element-251" data-mp="20znjelvkbn7s">
                    <h3 className="text-[19px] font-semibold text-kosin-charcoal" data-id="element-252" data-mp="20yvo7c5vnri1">
                      {step.title}
                    </h3>
                    <p className="mt-1.5 text-[16px] leading-relaxed text-kosin-body" data-id="element-253" data-mp="1w2x4i1vhuxny">
                      {step.text}
                    </p>
                  </div>
                </li>)}
            </ol>

            <p className="mt-8 text-[15px] text-kosin-body" data-id="element-254" data-mp="2d285o25mywii">
              Prefer to talk it through?
            </p>
            <a href={PHONE_HREF} className="mt-1.5 inline-flex items-center gap-2 text-[18px] font-semibold text-kosin-charcoal hover:text-kosin-red transition-colors duration-150 ease-kosin" data-id="element-255" data-mp="2i0rs03o56abe">
              <PhoneIcon className="h-4 w-4 text-kosin-red" aria-hidden="true" data-id="element-256" data-mp="2rsnpbcielwek" />
              {PHONE_DISPLAY}
            </a>
          </div>

          <QuoteForm idPrefix="path" headingLevel={3} title="Start A Free Quote" className="border border-kosin-line shadow-none" data-id="element-257" data-mp="30rslwdaenfo3" />
        </div>
      </div>
    </section>;
}